const getEventTarget = (event) => {
    let node = null;
    if (event.composed && event.composedPath) {
        node = event.composedPath()[0];
    }
    if (!node && event.path) {
        node = event.path[0];
    }
    if (!node) {
        node = event.target;
    }
    return node;
};

export default getEventTarget;